import { gql } from '@apollo/client';
import { mutate } from '../../../../Services/Gateway/Apollo';

export const SUBSCRIBE_TO_NEWSLETTER = gql`
  mutation SubscribeToNewsletter(
    $newsletter: String!
    $email: String!
    $dataFields: NewsletterDataFieldsInput!
  ) {
    subscribeToNewsletter(
      newsletter: $newsletter
      email: $email
      dataFields: $dataFields
    ) {
      status
      message
    }
  }
`;

/**
 * Apollo request
 */
const subscribeToNewsletterMutation = async (variables) => {
  const response = await mutate({
    mutation: SUBSCRIBE_TO_NEWSLETTER,
    variables,
  });

  return response.data.status;
};

export default subscribeToNewsletterMutation;
